export default __webpack_public_path__ + "media/images/article-bg-19c1215e1395450191b3f979c74b37ab.jpg";